import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/finalists", label: "入围名单" },
  { to: "/ranking", label: "排名结果" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const overlay = isHome && !scrolled && !open;
  const textColor = overlay ? "text-background-50" : "text-foreground-900";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        overlay ? "bg-transparent" : "bg-background-50/95 backdrop-blur border-b border-background-200"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-[68px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="爆料大赛首页">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-xl">
            <i className="ri-fire-fill" />
          </span>
          <span className={`font-heading text-xl tracking-wide ${textColor}`}>爆料大赛</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? overlay
                      ? "text-background-50 bg-background-50/20"
                      : "text-primary-600 bg-primary-50"
                    : overlay
                      ? "text-background-100 hover:text-background-50 hover:bg-background-50/15"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/ranking"
            className={`text-sm font-medium whitespace-nowrap transition-colors ${overlay ? "text-background-50 hover:text-accent-300" : "text-foreground-700 hover:text-primary-600"}`}
          >
            实时榜单
          </Link>
          <Link
            to="/finalists"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            参与投票
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开导航菜单"
          aria-expanded={open}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-2xl cursor-pointer ${overlay ? "text-background-50" : "text-foreground-900"}`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium ${
                    isActive ? "text-primary-600 bg-primary-50" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/finalists"
              className="mt-2 px-3 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-bold text-center whitespace-nowrap"
            >
              参与投票
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}